import {
  instance as axios,
  getToken,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/AxiosInstance";

// ------------Get Groups Listing-------------
export const groupListingApi = async (data) => {
  let endPoint;
  const { type, ...restData } = data;

  if (type === "explore") {
    endPoint =
      `user/group/explored/list` +
      "?" +
      new URLSearchParams(restData).toString().replace(/\+/g, '%20');
  } else {
    endPoint =
      `user/group/joined/list` + "?" + new URLSearchParams(data).toString();
  }

  return await axios.get(endPoint, setJwtToken());
};

// Favourite Group Listing
export const favouriteGroupListingApi = async (data) => {
  let endPoint;
  endPoint =
    `user/group-favorite/list` + "?" + new URLSearchParams(data).toString();

  return await axios.get(endPoint, setJwtToken());
};

// ------------Create Group-------------
export const createGroupApi = async (data) => {
  return await axios.post(`user/group`, data, setMultiPartHeader());
};

// ------------Update Group-------------
export const updateGroupApi = async (data) => {
  return await axios.put(`user/group`, data, setMultiPartHeader());
};

//----------------Delete Group API----------------
export const deleteGroupApi = async (data) => {
  // console.log(data,"Data");
  const endPoint = `user/group` + "?" + new URLSearchParams(data).toString();
  return await axios.delete(endPoint, setJwtToken());
};

// ------------Get Groups Detail-------------
export const groupDetailApi = async (data) => {
  const endPoint = `user/group` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};

//----------------Join Group API----------------
export const joinGroupApi = async (data) => {
  const endPoint = `user/group-member/join`;
  return await axios.post(endPoint, data, setJwtToken());
};

// Connected Group List
export const connectedGroupListApi = async (data) => {
  const endPoint = `user/group/connected/list` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Group Preference
export const groupPreferenceApi = async (data) => {
  const endPoint = `user/group`;
  return await axios.put(endPoint, data, setJwtToken());
};

// Group List Api
export const groupListApi = async (data) => {
  const endPoint = `user/group/list` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Favorite Group Update 
export const updateFavouriteListApi = async (data) => {
  const endPoint = `user/group-favorite`;
  return await axios.put(endPoint, data, setJwtToken());
};

// ------------fetch-Subscription-PlanApi-------------
export const fetchSubscriptionPlanApi = async (data) => {
  const endPoint = `user/subscription/plan/list` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};
//----------------add-Subscription-Api----------------
export const addSubscriptionApi = async (data) => {
  const endPoint = `user/subscription`;
  return await axios.post(endPoint, data, setJwtToken());
};

//----------------exit-Group-Api----------------
export const exitGroupApi = async (data) => {
  const endPoint = `/user/group-member`;
  return await axios.delete(endPoint, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data
  });
};

export const verifyStripeAccountApi = async (data) => {
  const endPoint = `public/connected-account/auth-verification`;
  return axios.post(endPoint, data, setJwtToken());
};
